import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mxn-cashin-form',
  templateUrl: './mxn-cashin-form.component.html',
  styleUrl: '../../add-cashin.component.scss',
  // Mantiene la fila del formulario como hija visual directa del layout padre.
  styles: [':host { display: contents; }'],
})
export class MxnCashinFormComponent implements OnInit {
  @Input() ctx!: any;

  readonly bitsoMxProtocolOptions = [
    { value: 'clabe', label: 'SPEI - CLABE (cuenta bancaria)' },
    { value: 'debitcard', label: 'SPEI - Tarjeta débito' },
    { value: 'phonenum', label: 'SPEI - Número móvil' },
  ];

  ngOnInit(): void {
    this.ctx.declarationCashinForm.patchValue({
      protocol: this.ctx.declarationCashinForm.controls.protocol.value || 'clabe',
    });
  }

  get selectedProtocol(): string {
    return this.ctx.declarationCashinForm.controls.protocol.value ?? 'clabe';
  }

  get bitsoMxClabeLabel(): string {
    if (this.selectedProtocol === 'debitcard') return 'Número de tarjeta débito';
    if (this.selectedProtocol === 'phonenum') return 'Número móvil (10 dígitos típ.)';
    return 'CLABE (18 dígitos)';
  }

  get bitsoMxClabePlaceholder(): string {
    if (this.selectedProtocol === 'debitcard') return '16 dígitos de la tarjeta';
    if (this.selectedProtocol === 'phonenum') return 'Ej. 8180833954';
    return '18 dígitos CLABE';
  }

  get needsInstitutionCode(): boolean {
    return (
      this.selectedProtocol === 'debitcard' ||
      this.selectedProtocol === 'phonenum'
    );
  }
}
